import * as React from 'react'
import { cn } from '~/lib/utils'

// 미니멀 텍스트 입력 — 시맨틱 토큰만, 다크 자동 적응.
// size prop(sm=h-7 / md=h-8)을 지원하고 className은 덧붙인다. error면 destructive 보더 + aria-invalid.
export type InputProps = Omit<React.ComponentProps<'input'>, 'size'> & {
    size?: 'sm' | 'md' | 'lg'
    error?: boolean
}

/** 텍스트 입력. */
function Input({
    className,
    type = 'text',
    size = 'md',
    error = false,
    ref,
    ...props
}: InputProps) {
    return (
        <input
            ref={ref}
            type={type}
            data-slot='input'
            aria-invalid={error || undefined}
            className={cn(
                'border-input bg-card text-foreground placeholder:text-muted-foreground focus:border-primary focus:ring-ring/20 disabled:bg-muted w-full rounded-[var(--radius)] border px-2.5 text-[13px] transition-colors focus:ring-2 focus:outline-none disabled:opacity-50',
                size === 'sm' ? 'h-7' : 'h-8',
                error &&
                    'border-destructive focus:border-destructive focus:ring-destructive/20',
                className
            )}
            {...props}
        />
    )
}

export { Input }
